<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="600"
  >
    <v-card>
      <v-card-text>
        <v-form
          ref="formNewContactoDeEntidadTecnica"
          lazy-validation
          @submit.prevent="save()"
        >
          <v-card-title class="pa-2">
            {{ isEdit ? 'Modificar contacto' : 'Crear contacto' }}
            <v-spacer />
          </v-card-title>

          <div>
            <v-text-field
              v-model="contactName"
              class="px-2 py-1"
              :rules="[v => !!v || 'El nombre del contacto es obligatorio']"
              flat
              label="Nombre de contacto"
              outlined
              required
            />

          </div>

          <v-row>
            <v-col
              cols="6"
            >
              <div>
              <v-text-field
                v-model="contactTelephone"
                label="Teléfono Personal"
                type="tel"
                class="px-2 py-1"
                flat
                outlined
                required
              />
              </div>
            </v-col>

              <v-col
              cols="6"
            >
              <div>
                <v-text-field
                  v-model="contactTelephone2"
                  class="px-2 py-1"
                  flat
                  label="Teléfono Corporativo"
                  required
                  outlined
                />
              </div>
            </v-col>
          </v-row>

          <div>
            <v-text-field
              v-model="addressContact"
              class="px-2 py-1"
              flat
              label="Direccion de oficina"
              required
              outlined
            />
          </div>

          <div>
            <v-text-field
              v-model="emailContact"
              class="px-2 py-1"
              flat
              label="Email Personal"
              required
              outlined
            />
          </div>

          <div>
            <v-text-field
              v-model="emailContact2"
              class="px-2 py-1"
              flat
              label="Email Corporativo"
              required
              outlined
            />
          </div>

          <div>
            <v-text-field
              v-model="empresa"
              class="px-2 py-1"
              flat
              label="Empresa"
              required
              outlined
            />
          </div>

          <div>
            <v-text-field
              v-model="cargo"
              class="px-2 py-1"
              flat
              label="Cargo"
              required
              outlined
            />
          </div>

          <v-card-actions class="pa-2">
            <v-btn
              outlined
              @click="close"
            >
              Cancelar
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              type="submit"
              :loading="loading"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

  // import firebase from 'firebase'

  // const db = firebase.firestore()

  export default {
    props: {
      entidadId: {
        type: Number,
        default: 0
      },
    },
    data () {
      return {
        dialog: false,
        loading: false,
        contact: undefined,
        contactName: '',
        contactTelephone: '',
        contactTelephone2: '',
        addressContact: '',
        emailContact: '',
        emailContact2: '',
        cargo: '',
        empresa: ''
      }
    },
    computed: {
      isEdit () {
        return this.contact === undefined ? false : 'as'
      },
    },
    methods: {
      open (item) {
        this.dialog = true
        this.contact = item
        if (this.isEdit) {
          this.contactName = item.nombre
          this.contactTelephone = item.telefono
          this.contactTelephone2 = item.telefono2
          this.addressContact = item.direccion
          this.emailContact = item.email
          this.emailContact2 = item.email2
          this.cargo = item.cargo
          this.empresa = item.empresa
        }
      },
      close () {
        this.dialog = false
        this.$refs.formNewContactoDeEntidadTecnica.reset()
        this.loading = false
      },
      async save () {
        if (this.$refs.formNewContactoDeEntidadTecnica.validate() && this.isEdit === false) {
          this.loading = true
          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/contacto', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                nombre: this.contactName ? this.contactName : '',
                telefono: this.contactTelephone ? this.contactTelephone : '',
                telefono2: this.contactTelephone2 ? this.contactTelephone2 : '',
                direccion: this.addressContact ? this.addressContact : '',
                email: this.emailContact ? this.emailContact : '',
                email2: this.emailContact2 ? this.emailContact2 : '',
                cargo: this.cargo || '',
                empresa: this.empresa || '',
                // entidad_tecnica_id: this.entidadId ? this.entidadId : '',
                entidad_tecnica_id: this.entidadId || ''
              })
            })
            const data = await response.json()
            if (data.success) {}

            this.close()
            this.$emit('onCreate')
        } else {
          if (this.isEdit && this.$refs.formNewContactoDeEntidadTecnica.validate()) {
            this.loading = true
            const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/contacto/' + this.contact.id, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                nombre: this.contactName ? this.contactName : '',
                telefono: this.contactTelephone ? this.contactTelephone : '',
                telefono2: this.contactTelephone2 ? this.contactTelephone2 : '',
                direccion: this.addressContact ? this.addressContact : '',
                email: this.emailContact ? this.emailContact : '',
                email2: this.emailContact2 ? this.emailContact2 : '',
                empresa: this.empresa || '',
                cargo: this.cargo || '',
              })
            })
            const data = await response.json()
            if (data.success) {}
            this.close()
            this.$emit('onCreate')
          }
        }
      },
    },
  }
</script>
